import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/themes.css';

import { msalConfig } from './msal-config';
import App from './App';
import { CookiesProvider } from 'react-cookie';
import {
  EventType,
  PublicClientApplication,
  AuthenticationResult,
} from '@azure/msal-browser';

// handle msal auth
const msalApp = new PublicClientApplication(msalConfig);
if (!msalApp.getActiveAccount() && msalApp.getAllAccounts().length > 0) {
  msalApp.setActiveAccount(msalApp.getAllAccounts()[0]);
}
msalApp.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS) {
    if (event.payload) {
      const pl: AuthenticationResult = event.payload as AuthenticationResult;
      msalApp.setActiveAccount(pl.account);
    }
  }
});

// add the build config as a comment
const build = document.createComment(`BUILD: ${process.env.REACT_APP_ENV}`);
document.body.appendChild(build);

// configure the cookie provider
const cookieOptions = {
  path: '/',
  domain: process.env.REACT_APP_SSO_COOKIE_DOMAIN,
  secure: true,
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <CookiesProvider defaultSetOptions={cookieOptions}>
    <App msalApp={msalApp} />
  </CookiesProvider>
);
